import type { Suggestion } from '../components/UI/SearchWithAutocomplete'
import type {
  BookData,
  MerchData,
  EventData,
  BookBoxData,
  CreativeServiceData,
  ServiceProviderData,
} from './productManagerTypes'
export const mockUsers = [
  {
    id: 'u1',
    name: 'Sarah Chen',
    avatar:
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100',
    verified: true,
    roles: ['Co-Writer', 'Editor'],
  },
  {
    id: 'u2',
    name: 'James Miller',
    avatar:
      'https://images.unsplash.com/photo-1599566150163-29194dcaad36?w=100',
    verified: true,
    roles: ['Co-Writer', 'Cover Artist'],
  },
  {
    id: 'u3',
    name: 'Emily Wilson',
    avatar:
      'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100',
    verified: false,
    roles: ['Editor', 'Formatter'],
  },
  {
    id: 'u4',
    name: 'David Kim',
    avatar:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100',
    verified: true,
    roles: ['Cover Artist', 'Other'],
  },
  {
    id: 'u5',
    name: 'Lisa Park',
    avatar:
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100',
    verified: true,
    roles: ['Formatter', 'Editor'],
  },
  {
    id: 'u6',
    name: 'Michael Torres',
    avatar:
      'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100',
    verified: false,
    roles: ['Co-Writer', 'Other'],
  },
  {
    id: 'u7',
    name: 'Anna Schmidt',
    avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100',
    verified: true,
    roles: ['Cover Artist'],
  },
  {
    id: 'u8',
    name: 'Robert Chen',
    avatar:
      'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100',
    verified: true,
    roles: ['Author', 'Designer', 'Artist'],
  },
]
export const mockBooks: BookData[] = [
  {
    id: 'b1',
    title: 'The Silent Echo',
    author: 'You',
    description: 'A gripping tale of love and loss...',
    genre: 'Romance',
    subgenre: 'Dark Romance',
    price: 24.99,
    isbn: '978-1234567890',
    pageCount: 350,
    publishDate: '2024-03-15',
    coverImage:
      'https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=400',
    tags: ['Enemies to Lovers', 'Slow Burn', 'Angst'],
    contentWarnings: ['Violence', 'Strong Language'],
    spiceLevel: 4,
    relationshipType: 'M/F',
    themes: ['Second Chance', 'Small Town'],
    series: {
      name: 'Echo Series',
      position: 1,
    },
    collaborators: [],
    externalLinks: [],
    ageRating: '18+',
    formats: {
      ebook: {
        available: true,
        price: 9.99,
      },
      audiobook: {
        available: true,
        price: 19.99,
      },
      print: {
        available: true,
        price: 24.99,
      },
    },
  },
  {
    id: 'b2',
    title: 'Midnight Whispers',
    author: 'You',
    description: 'When darkness falls, secrets emerge...',
    genre: 'Fantasy',
    subgenre: 'Urban Fantasy',
    price: 19.99,
    isbn: '978-0987654321',
    pageCount: 420,
    publishDate: '2025-05-20',
    coverImage:
      'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?w=400',
    tags: ['Magic', 'Found Family', 'Quest'],
    contentWarnings: ['Violence'],
    spiceLevel: 2,
    collaborators: [],
    externalLinks: [],
    ageRating: '16+',
    formats: {
      ebook: {
        available: true,
        price: 7.99,
      },
      audiobook: {
        available: false,
        price: 0,
      },
      print: {
        available: true,
        price: 19.99,
      },
    },
  },
  {
    id: 'b3',
    title: "Dragon's Crown",
    author: 'You',
    description: 'The epic conclusion to the Crown Saga...',
    genre: 'Fantasy',
    subgenre: 'Epic Fantasy',
    price: 29.99,
    isbn: '978-1122334455',
    pageCount: 520,
    publishDate: '2025-06-05',
    coverImage:
      'https://images.unsplash.com/photo-1626788353765-b55f9fc8daf9?w=400',
    tags: ['Dragons', 'Epic Quest', 'Magic'],
    contentWarnings: ['Violence', 'Death'],
    spiceLevel: 1,
    series: {
      name: 'Crown Saga',
      position: 3,
    },
    collaborators: [],
    externalLinks: [],
    ageRating: '13+',
    formats: {
      ebook: {
        available: true,
        price: 12.99,
      },
      audiobook: {
        available: true,
        price: 24.99,
      },
      print: {
        available: true,
        price: 29.99,
      },
    },
  },
  {
    id: 'c1',
    title: 'Shadows of Tomorrow',
    author: 'You & Sarah Chen',
    description: 'A collaborative sci-fi adventure...',
    genre: 'Science Fiction',
    subgenre: 'Space Opera',
    price: 22.99,
    isbn: '978-5566778899',
    pageCount: 380,
    publishDate: '2024-04-20',
    coverImage:
      'https://images.unsplash.com/photo-1633477189729-9290b3261d0a?w=400',
    tags: ['Space', 'Adventure', 'AI'],
    contentWarnings: ['Violence'],
    spiceLevel: 2,
    collaborators: [
      {
        id: 'u1',
        name: 'Sarah Chen',
        role: 'Co-Writer',
        verified: true,
        status: 'verified',
        avatar:
          'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100',
      },
    ],
    externalLinks: [],
    ageRating: '16+',
    formats: {
      ebook: {
        available: true,
        price: 8.99,
      },
      audiobook: {
        available: true,
        price: 18.99,
      },
      print: {
        available: true,
        price: 22.99,
      },
    },
  },
  {
    id: 'c2',
    title: 'The Last Summer',
    author: 'You & James Miller',
    description: 'A heartwarming romance collaboration...',
    genre: 'Romance',
    subgenre: 'Contemporary Romance',
    price: 18.99,
    isbn: '978-9988776655',
    pageCount: 320,
    publishDate: '2025-07-10',
    coverImage:
      'https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=400',
    tags: ['Summer Romance', 'Second Chance', 'Small Town'],
    contentWarnings: [],
    spiceLevel: 3,
    collaborators: [
      {
        id: 'u2',
        name: 'James Miller',
        role: 'Co-Writer',
        verified: true,
        status: 'verified',
        avatar:
          'https://images.unsplash.com/photo-1599566150163-29194dcaad36?w=100',
      },
    ],
    externalLinks: [],
    ageRating: '18+',
    formats: {
      ebook: {
        available: true,
        price: 6.99,
      },
      audiobook: {
        available: false,
        price: 0,
      },
      print: {
        available: true,
        price: 18.99,
      },
    },
  },
]
export const mockMerch: MerchData[] = [
  {
    id: 'm1',
    name: 'Echo Series T-Shirt',
    description: 'Official merchandise for the Echo Series',
    price: 29.99,
    category: 'Apparel',
    relatedBook: 'b1',
    images: [
      'https://images.unsplash.com/photo-1576566588028-4147f3842f27?w=400',
    ],
    inventory: 50,
    ageRating: 'all',
    tropes: [],
    linkedCreators: [],
    externalLinks: [],
  },
]
export const mockEvents: EventData[] = [
  {
    id: '1',
    title: 'Book Signing: The Silent Echo',
    type: 'Book Signing',
    description: 'Meet the author and get your copy signed!',
    startDate: '2024-03-20',
    endDate: '2024-03-20',
    time: '14:00-16:00',
    location: 'Bright Pages Bookstore, Seattle',
    capacity: 50,
    isVirtual: false,
    image: 'https://images.unsplash.com/photo-1528605105345-5344ea20e269?w=400',
    banner:
      'https://images.unsplash.com/photo-1528605105345-5344ea20e269?w=400',
    ageRating: 'all',
    relatedBooks: ['b1'],
    collaborators: [],
    externalLinks: [],
    tags: [],
  },
  {
    id: '2',
    title: 'Virtual Q&A Session',
    type: 'Virtual Event',
    description: 'Join me for a live Q&A about the writing process',
    startDate: '2024-03-25',
    endDate: '2024-03-25',
    time: '19:00-20:30',
    location: 'Online',
    capacity: 100,
    isVirtual: true,
    virtualLink: 'https://zoom.us/...',
    image: 'https://images.unsplash.com/photo-1517971129774-8a2b38fa128e?w=400',
    ageRating: 'all',
    relatedBooks: [],
    collaborators: [],
    externalLinks: [],
    tags: [],
  },
  {
    id: '3',
    title: 'Literary Festival',
    type: 'Festival',
    description: 'Annual literary festival with multiple authors',
    startDate: '2024-04-18',
    endDate: '2024-04-22',
    time: 'All Day',
    location: 'City Convention Center',
    capacity: 1000,
    isVirtual: false,
    image: 'https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?w=400',
    ageRating: 'all',
    relatedBooks: [],
    collaborators: [],
    externalLinks: [],
    tags: [],
  },
  {
    id: '4',
    title: 'Writing Workshop Series',
    type: 'Workshop',
    description: 'Learn the craft of writing romance novels',
    startDate: '2024-04-10',
    endDate: '2024-04-12',
    time: '10:00-12:00',
    location: 'Community Center, Seattle',
    capacity: 25,
    isVirtual: false,
    image: 'https://images.unsplash.com/photo-1532012197267-da84d127e765?w=400',
    ageRating: '16+',
    relatedBooks: [],
    collaborators: [],
    externalLinks: [],
    tags: [],
  },
  {
    id: '5',
    title: 'Author Meet & Greet Tour',
    type: 'Meet & Greet',
    description: 'Multi-city tour to meet readers',
    startDate: '2024-04-25',
    endDate: '2024-04-28',
    time: '15:00-17:00',
    location: 'Various Locations',
    capacity: 200,
    isVirtual: false,
    image: 'https://images.unsplash.com/photo-1528605105345-5344ea20e269?w=400',
    ageRating: 'all',
    relatedBooks: [],
    collaborators: [],
    externalLinks: [],
    tags: [],
  },
]
export const mockBookBoxes: BookBoxData[] = [
  {
    id: 'bb1',
    boxName: 'Bookish & Spice',
    theme: 'Romance, Erotic, Sensual',
    description:
      'A monthly subscription box filled with spicy romance novels, themed goodies, and exclusive author swag.',
    price: 39.99,
    currency: 'AUD',
    frequency: 'Monthly',
    includedItems: [
      '1-2 spicy romance novels',
      'Bookish candle',
      'Exclusive bookmark',
      'Author signed bookplate',
      'Themed goodies (stickers, pins)',
    ],
    tags: ['romance', 'spicy', 'subscription', 'book box'],
    contentsOverview:
      'Each box focuses on a romance subgenre with a mix of new releases and fan favorites.',
    boxImage:
      'https://images.unsplash.com/photo-1603162361777-1f802e442ecf?w=400',
    subscriptionUrl: 'https://bookishandspice.com/subscribe',
    shipping: 'Worldwide',
    customizationOptions: [
      'Choose heat level: mild, medium, hot',
      'Add extra swag pack',
    ],
    locationCountry: 'Australia',
    ageRating: '18+',
    genre: 'Romance',
    tropes: ['Enemies to Lovers', 'Forced Proximity', 'Slow Burn'],
    contentWarnings: ['Sexual Content', 'Strong Language'],
    spiceLevel: 4,
    collaborators: [],
    externalLinks: [],
  },
  {
    id: 'bb2',
    boxName: 'Fantasy Realm Crate',
    theme: 'Fantasy, Epic, Adventure',
    description:
      'A monthly box packed with fantasy novels, themed collectibles, and fan-favorite merchandise.',
    price: 44.95,
    currency: 'GBP',
    frequency: 'Monthly',
    includedItems: [
      '1-2 fantasy novels',
      'Collectible figurine or pin',
      'Themed art print',
      'Exclusive bookmark',
      'Fan merch (stickers, patches)',
    ],
    tags: ['fantasy', 'subscription', 'book box', 'collectibles'],
    contentsOverview:
      'Explore new worlds with curated fantasy picks and collectible items.',
    boxImage: 'https://images.unsplash.com/photo-1550859492-d5da9d8e45f3?w=400',
    subscriptionUrl: 'https://fantasyrealmcrate.com/subscribe',
    shipping: 'Worldwide',
    customizationOptions: [
      'Choose preferred fantasy subgenre',
      'Add extra collectible item',
    ],
    locationCountry: 'United Kingdom',
    ageRating: '13+',
    genre: 'Fantasy',
    tropes: ['Chosen One', 'Found Family', 'Magic School'],
    contentWarnings: ['Fantasy Violence', 'Mild Language'],
    spiceLevel: 1,
    collaborators: [],
    externalLinks: [],
  },
]
export const mockCreativeServices: CreativeServiceData[] = [
  {
    id: 'cs1',
    displayName: 'Alex Rivera',
    role: 'Cover Designer',
    bio: 'I specialize in crafting immersive book covers for Fantasy and Sci-Fi authors.',
    specialties: ['Fantasy', 'Sci-Fi', 'Typography'],
    queueStatus: 'open',
    slotsAvailable: 3,
    maxSlots: 5,
    estimatedWait: '2 weeks',
    processSteps: [
      {
        title: 'Discovery',
        description: 'Manuscript review & mood boards',
      },
      {
        title: 'Concepts',
        description: 'Loose sketches & composition',
      },
    ],
    services: [
      {
        id: 's1',
        name: 'eBook Essentials',
        price: '$250',
        description: 'Perfect for indie authors.',
        features: ['High-res eBook Cover', '3D Mockup'],
        turnaround: '2 weeks',
        revisions: '2 rounds',
      },
    ],
    portfolioImages: [
      {
        id: 'p1',
        imageUrl:
          'https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=400',
        title: 'The Starless Sea',
        category: 'Cover Design',
        aspectRatio: 'portrait',
      },
    ],
    willDo: ['Fantasy', 'Sci-Fi', 'Young Adult'],
    wontDo: ['Horror', 'Erotica'],
    externalLinks: [],
  },
]
export const serviceProviderRoles = [
  'Editor',
  'Formatter',
  'Proofreader',
  'Personal Assistant',
  'Book Coach',
  'Sensitivity Reader',
  'Translator',
  'Ghostwriter',
]
export const mockServiceProviders: ServiceProviderData[] = [
  {
    id: 'sp1',
    displayName: "Emma's Editing Services",
    role: 'Developmental Editor',
    bio: 'Specializing in developmental editing for romance and fantasy novels.',
    specialties: ['Romance', 'Fantasy', 'Character Development'],
    queueStatus: 'open',
    slotsAvailable: 4,
    maxSlots: 6,
    estimatedWait: '2-3 weeks',
    rateType: 'per-word',
    startingRate: '$0.02/word',
    services: [
      {
        id: 'sps1',
        name: 'Developmental Edit',
        price: '$0.02/word',
        description:
          'Full manuscript developmental edit with detailed feedback.',
        features: [
          'Detailed editorial letter',
          'In-line comments',
          'Follow-up call',
        ],
        turnaround: '4-6 weeks',
        revisions: '1 round',
        isPopular: true,
        category: 'Editing',
      },
    ],
    qualifications: [
      'BA in English Literature',
      '10+ years editing experience',
      'EFA member',
    ],
    willDo: ['Romance', 'Fantasy', 'YA', "Women's Fiction"],
    wontDo: ['Horror', 'Erotica', 'Non-fiction'],
    externalLinks: [],
  },
]
export const genreOptions = [
  'Romance',
  'Fantasy',
  'Science Fiction',
  'Mystery',
  'Thriller',
  'Horror',
]
export const eventTypes = [
  'Book Signing',
  'Virtual Event',
  'Workshop',
  'Festival',
  'Meet & Greet',
  'Book Club',
]
export const merchCategories = [
  'Apparel',
  'Accessories',
  'Prints',
  'Stationery',
  'Collectibles',
]
export const frequencyOptions = ['Monthly', 'Bi-Monthly', 'Quarterly']
export const currencyOptions = ['USD', 'GBP', 'AUD', 'CAC', 'EUR', 'JPY', 'KRW']
export const shippingOptions = [
  'Worldwide',
  'US Only',
  'US & Canada',
  'UK & Europe',
  'Australia',
  'Japan, Asia',
  'South Korea, Worldwide',
]
export const countryOptions = [
  'United States',
  'United Kingdom',
  'Australia',
  'Canada',
  'Japan',
  'South Korea',
  'Mexico',
  'Germany',
  'France',
]
export const tropeSuggestions: Suggestion[] = [
  {
    id: 't1',
    label: 'Enemies to Lovers',
    type: 'Trope',
  },
  {
    id: 't2',
    label: 'Friends to Lovers',
    type: 'Trope',
  },
  {
    id: 't3',
    label: 'Fake Dating',
    type: 'Trope',
  },
  {
    id: 't4',
    label: 'Forced Proximity',
    type: 'Trope',
  },
  {
    id: 't5',
    label: 'Slow Burn',
    type: 'Trope',
  },
  {
    id: 't6',
    label: 'Second Chance',
    type: 'Trope',
  },
  {
    id: 't7',
    label: 'Grumpy x Sunshine',
    type: 'Trope',
  },
  {
    id: 't8',
    label: 'Found Family',
    type: 'Trope',
  },
  {
    id: 't9',
    label: 'Chosen One',
    type: 'Trope',
  },
  {
    id: 't10',
    label: 'Secret Identity',
    type: 'Trope',
  },
]
export const tagSuggestions: Suggestion[] = [
  {
    id: 'tag1',
    label: 'Magic',
    type: 'Setting',
  },
  {
    id: 'tag2',
    label: 'Dragons',
    type: 'Setting',
  },
  {
    id: 'tag3',
    label: 'Space',
    type: 'Setting',
  },
  {
    id: 'tag4',
    label: 'Vampires',
    type: 'Setting',
  },
  {
    id: 'tag5',
    label: 'Werewolves',
    type: 'Setting',
  },
  {
    id: 'tag6',
    label: 'Royalty',
    type: 'Setting',
  },
  {
    id: 'tag7',
    label: 'Small Town',
    type: 'Setting',
  },
  {
    id: 'tag8',
    label: 'Cyberpunk',
    type: 'Setting',
  },
]
export const warningSuggestions: Suggestion[] = [
  {
    id: 'w1',
    label: 'Violence',
    type: 'Warning',
  },
  {
    id: 'w2',
    label: 'Strong Language',
    type: 'Warning',
  },
  {
    id: 'w3',
    label: 'Death',
    type: 'Warning',
  },
  {
    id: 'w4',
    label: 'Gore',
    type: 'Warning',
  },
  {
    id: 'w5',
    label: 'Sexual Content',
    type: 'Warning',
  },
  {
    id: 'w6',
    label: 'Abuse',
    type: 'Warning',
  },
  {
    id: 'w7',
    label: 'Self-harm',
    type: 'Warning',
  },
]
const relationshipTypes = [
  'M/F',
  'M/M',
  'F/F',
  'MMF',
  'FFM',
  'MMMF',
  'Why Choose (WC)',
  'Poly',
]
export const relationshipSuggestions: Suggestion[] = relationshipTypes.map(
  (type, idx) => ({
    id: `rel${idx}`,
    label: type,
    type: 'Relationship',
  }),
)
export const themeSuggestions: Suggestion[] = [
  {
    id: 'th1',
    label: 'Second Chance',
    type: 'Theme',
  },
  {
    id: 'th2',
    label: 'Forbidden Love',
    type: 'Theme',
  },
  {
    id: 'th3',
    label: 'Small Town',
    type: 'Theme',
  },
  {
    id: 'th4',
    label: 'Billionaire',
    type: 'Theme',
  },
  {
    id: 'th5',
    label: 'Mafia',
    type: 'Theme',
  },
  {
    id: 'th6',
    label: 'Sports',
    type: 'Theme',
  },
  {
    id: 'th7',
    label: 'Military',
    type: 'Theme',
  },
  {
    id: 'th8',
    label: 'Rockstar',
    type: 'Theme',
  },
  {
    id: 'th9',
    label: 'Holiday',
    type: 'Theme',
  },
  {
    id: 'th10',
    label: 'Workplace',
    type: 'Theme',
  },
  {
    id: 'th11',
    label: 'College',
    type: 'Theme',
  },
  {
    id: 'th12',
    label: 'Age Gap',
    type: 'Theme',
  },
  {
    id: 'th13',
    label: 'Marriage of Convenience',
    type: 'Theme',
  },
  {
    id: 'th14',
    label: 'Arranged Marriage',
    type: 'Theme',
  },
  {
    id: 'th15',
    label: 'Secret Baby',
    type: 'Theme',
  },
]
export const allContentSuggestions: Suggestion[] = [
  ...tropeSuggestions,
  ...tagSuggestions,
  ...warningSuggestions,
  ...themeSuggestions,
  ...relationshipSuggestions,
]
export const getContentTagColor = (
  category: string = 'Trope',
  darkMode: boolean,
) => {
  switch (category) {
    case 'Trope':
      return darkMode
        ? 'bg-purple-900/50 text-purple-300'
        : 'bg-purple-100 text-purple-900'
    case 'Setting':
    case 'Tag':
      return darkMode
        ? 'bg-green-900/50 text-green-300'
        : 'bg-green-100 text-green-900'
    case 'Warning':
    case 'Content Warning':
      return darkMode
        ? 'bg-amber-900/50 text-amber-300'
        : 'bg-amber-100 text-amber-900'
    case 'Theme':
      return darkMode
        ? 'bg-blue-900/50 text-blue-300'
        : 'bg-blue-100 text-blue-900'
    case 'Relationship':
      return darkMode
        ? 'bg-pink-900/50 text-pink-300'
        : 'bg-pink-100 text-pink-900'
    default:
      return darkMode
        ? 'bg-gray-700 text-gray-300'
        : 'bg-gray-100 text-gray-900'
  }
}
